module.exports = __webpack_public_path__ + "static/media/camera-icon-white.dc907a64.svg";